import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "../Footer";

// Quiet top bar for standalone legal pages — no hero image, so it stays solid.
export default function LegalLayout({ children }) {
    return (
        <div style={{ backgroundColor: "var(--bg)", minHeight: "100vh" }}>
            <header
                className="fixed left-0 right-0 top-0 z-50"
                style={{
                    backgroundColor: "rgba(252,251,248,0.9)",
                    backdropFilter: "blur(14px)",
                    borderBottom: "1px solid var(--line)",
                }}
            >
                <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4 md:px-8">
                    <Link
                        to="/"
                        data-testid="legal-logo-home"
                        className="cursor-pointer"
                    >
                        <span className="logo-frame inline-block">
                            <span
                                className="font-serif text-2xl"
                                style={{ letterSpacing: "0.02em" }}
                            >
                                Lady<span style={{ color: "var(--accent)" }}>Art</span>
                            </span>
                        </span>
                    </Link>
                    <Link
                        to="/"
                        data-testid="legal-back-home"
                        className="eyebrow eyebrow-ink link-underline inline-flex items-center gap-2"
                    >
                        <ArrowLeft size={14} strokeWidth={1.6} />
                        Înapoi la site
                    </Link>
                </div>
            </header>

            <main className="pt-24 md:pt-28">{children}</main>

            <Footer />
        </div>
    );
}
